import { action } from 'easy-peasy';
import { IActionSetRelatedClients } from '../types';

const setRelatedClients: IActionSetRelatedClients = action((state, payload) => {
  state.relatedClients = payload;
});

export default setRelatedClients;
